export default __webpack_public_path__ + "static/media/verify_bg4.ee61a29a.png";